module.exports = __webpack_public_path__ + "static/media/hf_superior_tri.f629ca0a.jpg";